import $ from 'jquery';
import Helper from './utils/helper';
import Router from './utils/router';
import Landing from './views/landing';

export default class Routes {
    constructor() {
        new Router({
            routes: {
                '': 'landing',
                'state/:state/slide/:slide(/)': 'gallery'
            },

            landing: function() {
                new Landing();
            },

            gallery: function(state, slide) {
                let $base = $('body'),
                    $loader = $('.loader');

                if (Helper.isFireFox()) {
                    $base = $('html');
                    $loader.show();

                    $(window).load(function() {
                        $base.animate({
                            scrollTop: $('.map').offset().top
                        }, 400, function() {
                            $loader.fadeOut(() => {
                                new Landing({state: state, slide: slide});
                            });
                        });
                    });
                } else  {
                    $base.animate({
                        scrollTop: $('.map').offset().top
                    }, 400, function() {
                        new Landing({state: state, slide: slide});
                    });
                }
            }
        });
    }
}



/** WEBPACK FOOTER **
 ** ./frontend/js/routes.js
 **/